import useAnalyticsContext from '@client/hooks/useAnalyticsContext';
import AnalyticsConstants from '@constants/analytics';
import { useCallback } from 'react';

export const useTrackPricingFactorsCarousel = () => {
	const { track } = useAnalyticsContext();

	return useCallback(
		(newIndex?: number) => {
			if (newIndex === undefined) return;

			track({
				event: AnalyticsConstants.STOREFRONT_INTERACTION,
				properties: {
					action: 'swipe_pricing_carousel',
				},
			});
		},
		[track],
	);
};
